let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { css, keyframes } from 'styled-components';
import { memo, useContext } from 'react';
import { MEDIA_BUFFER_STATUSES } from '../../constants/MediaBufferStatus';
import { MediaPlaybackBufferContext } from '../../context/MediaPlaybackBufferContext';
import { MEDIA_PLAYER_COLORS } from '../../constants/Colors';
import { MediaPlayerBar } from './MediaPlayerBar';
import { jsx as _jsx } from "react/jsx-runtime";
const SHIMMER_ANIMATION = keyframes(["0%{background-position:0 0;}100%{background-position:1.5em 0;}"]);
export const animation = css(["animation:", " 1s linear infinite;"], SHIMMER_ANIMATION);
const AnimatedGradient = styledWithTheme.div(_t || (_t = _`
  display: block;
  position: absolute;
  inset: 0;
  background-color: ${0};
  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%, transparent 50%, rgba(0, 0, 0, 0.25) 50%, rgba(0, 0, 0, 0.25) 75%, transparent 75%, transparent);
  font-size: 30px;
  background-size: 1.5em 1.5em;
  opacity: 0.6;
  ${0}
`), ({
  theme
}) => theme.color[MEDIA_PLAYER_COLORS.DEFAULT_STATUS_FILL], animation);
const __MediaBufferWaitingIndicator = () => {
  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  const {
    bufferStatus
  } = useContext(MediaPlaybackBufferContext);
  if (bufferStatus !== MEDIA_BUFFER_STATUSES.BUFFERING) return null;
  return /*#__PURE__*/_jsx(MediaPlayerBar, {
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(AnimatedGradient, {})
  });
};
export const MediaBufferWaitingIndicator = /*#__PURE__*/memo(__MediaBufferWaitingIndicator);